import React from 'react';
import { Button } from 'takeat-design-system-ui-kit';
import ArrowClick from '~/assets/img/arrowClick.svg';
import { useAuth } from '~/context/AuthContext';

export default function GetDemoButton({ url }) {
  const { user } = useAuth();
  function handleClick() {
    window.open(`${url}?email=${user.restaurant_email}`, '_blank');
  }

  return (
    <Button
      onClick={handleClick}
      style={{
        width: 150,
        height: 30,
        borderRadius: 16,
        marginLeft: 8,
        fontSize: 12,
      }}
      type="button"
    >
      Tutorial aqui
      <img
        src={ArrowClick}
        alt="icone de clique"
        style={{
          width: 10,
          height: 24,
        }}
      />
    </Button>
  );
}
